import { head } from 'lodash';
import { urlPrefix } from '../clientConfig';

export default (link) => {
  if (head(link) === '/') return `${urlPrefix}${link}`;
  return link;
};
